import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/components/utils/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

// Varianti personalizzate per il profilo utente
const ProfileTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex w-full h-12 bg-transparent border-0 p-0 justify-start gap-4 md:gap-8 overflow-x-auto scrollbar-hide",
      className
    )}
    {...props}
  />
))
ProfileTabsList.displayName = "ProfileTabsList"

const ProfileTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "flex items-center gap-1 md:gap-2 py-3 px-2 md:px-1 border-b-2 font-medium text-xs md:text-sm transition-colors relative data-[state=active]:border-black data-[state=active]:text-black border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed whitespace-nowrap flex-shrink-0",
      className
    )}
    {...props}
  />
))
ProfileTabsTrigger.displayName = "ProfileTabsTrigger"

const ProfileTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-0",
      className
    )}
    {...props}
  />
))
ProfileTabsContent.displayName = "ProfileTabsContent"

// Varianti mobile per il profilo utente
const MobileProfileTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex w-full h-14 bg-white border-b border-gray-200 p-0 justify-around md:hidden",
      className
    )}
    {...props}
  />
))
MobileProfileTabsList.displayName = "MobileProfileTabsList"

const MobileProfileTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "flex flex-col items-center justify-center gap-1 py-2 px-1 border-b-2 font-medium text-xs transition-colors relative data-[state=active]:border-black data-[state=active]:text-black border-transparent text-gray-500 hover:text-gray-700 disabled:text-gray-400 disabled:cursor-not-allowed flex-1 min-w-0",
      className
    )}
    {...props}
  />
))
MobileProfileTabsTrigger.displayName = "MobileProfileTabsTrigger"

export { 
  Tabs, 
  TabsList, 
  TabsTrigger, 
  TabsContent,
  ProfileTabsList,
  ProfileTabsTrigger,
  ProfileTabsContent,
  MobileProfileTabsList,
  MobileProfileTabsTrigger
}
